import script from "./WebPlay.vue?vue&type=script&setup=true&lang=js"
export * from "./WebPlay.vue?vue&type=script&setup=true&lang=js"

import "./WebPlay.vue?vue&type=style&index=0&id=1e201df8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e201df8"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QTabPanels,QTabPanel,QBtn});
